import { Link } from "react-router-dom";

import useFetch from "../../hooks/useFetch";
import Spinner from "../../components/Spinner";

const UserCard = () => {

    const keyToClass = {
        "BARANGAY CLEARANCE"      : { colorClass: "success", iconClass: "fas fa-check-circle" },
        "BARANGAY INDIGENCY"      : { colorClass: "danger", iconClass: "fas fa-times-circle" },
        "CERTIFICATE OF RESIDENCY": { colorClass: "info", iconClass: "fas fa-info-circle" },
        "CERTIFICATION"           : { colorClass: "primary", iconClass: "fas fa-certificate" },
        "ESTATE TAX"              : { colorClass: "warning", iconClass: "fas fa-exclamation-circle" }
    };

    const {
        data: counter_per_certificate,
        isLoading,
        errorMessage,
    } = useFetch(`${process.env.REACT_APP_API_URL}/certificate_counter/`);

    return (
        <>
            <div className="row">


                {isLoading && <Spinner />}
                {errorMessage && <div>{errorMessage}</div>}



                {counter_per_certificate &&

                    Object.keys(counter_per_certificate).map(key => (



                <div  key={key}  className="col-lg col-sm mb-4">
                    <div className="card">
                        <div className="card-header d-flex align-items-center justify-content-between">
                        <h6 className="card-title m-0 me-2">{key}</h6>
                        <div className="dropdown">
                            <button className="btn btn-sm p-0" type="button" id="totalSalesList" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            Today <i className="bx bx-chevron-down" />
                            </button>
                            <div className="dropdown-menu dropdown-menu-end" aria-labelledby="totalSalesList">
                            <Link className="dropdown-item">Yesterday</Link>
                            <Link className="dropdown-item">Last Week</Link>
                            <Link className="dropdown-item">Last Month</Link>
                            </div>
                        </div>
                        </div>
                        <div className="card-body text-center">
                        <div className={`avatar avatar-md border-5 border-light-${keyToClass[key].colorClass} rounded-circle mx-auto mb-4`}>
                            <span className={`avatar-initial rounded-circle bg-label-${keyToClass[key].colorClass}`}><i className="bx bx-trending-up bx-sm" /></span>
                        </div>
                        <h3 className="card-title mb-1 me-2">{counter_per_certificate[key]}</h3>
                        </div>
                    </div>
                    </div>


 
                    ))
                }
            </div>



        </>
    );
}

export default UserCard;